// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"85122596","596":"afb227a8","666":"c6284424","989":"89540e5c"}[chunkId] + ".chunk.js";
};